"use client";

import { useRef, useState } from "react";
import { Swiper, SwiperRef, SwiperSlide } from "swiper/react";
import { Container } from "@/components/ui/container";
import SliderArrowButton from "@/components/entities/slider-arrow-button";
import S from "./index.module.scss";
import { FreeMode } from "swiper/modules";
import Picture from "@/components/ui/picture";
import { ImageDTO } from "@/api/generated-api";

interface PhotoGalleryProps {
  gallery: ImageDTO[];
}

const PhotoGallery = ({ gallery }: PhotoGalleryProps) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const swiperRef = useRef<SwiperRef>(null);

  const handleNext = () => {
    if (swiperRef.current && currentIndex < gallery.length) {
      swiperRef.current.swiper.slideNext();
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (swiperRef.current && currentIndex !== 0) {
      swiperRef.current.swiper.slidePrev();
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <section className={S.gallery}>
      <Container className={S.container}>
        <div className={S.header}>
          <h2 className={S.title}>Фотогалерея</h2>
          <div className={S.controls}>
            <SliderArrowButton direction="prev" tone="dark" disabled={currentIndex === 0} onClick={handlePrev} />
            <SliderArrowButton
              direction="next"
              tone="dark"
              disabled={currentIndex === gallery.length - 1}
              onClick={handleNext}
            />
          </div>
        </div>

        <Swiper
          slidesPerView="auto"
          freeMode={{ enabled: true }}
          modules={[FreeMode]}
          className={S.track}
          ref={swiperRef}
          onSlideChange={swiper => setCurrentIndex(swiper.activeIndex)}
          breakpoints={{
            0: {
              spaceBetween: 20,
            },
            768: {
              spaceBetween: 40,
            },
          }}
        >
          {gallery.map((item, idx) => (
            <SwiperSlide key={idx} className={S.card}>
              <Picture image={item} width={600} height={700} className={S.cardImage} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default PhotoGallery;
